import { memo, useMemo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import { ReactComponent as CheckMarkIcon } from 'images/Icons/CheckMark.svg';

import styles from './ActionPoints.module.scss';

const ActionPoints = ({ items }) => {
  const itemsJSX = useMemo(
    () =>
      items.map(({ id, label, completed }) => (
        <div
          key={id}
          className={classNames(styles.item, {
            [styles.completed]: completed,
          })}
        >
          <div className={styles.circle}>
            {completed && <CheckMarkIcon className={styles.checkMarkIcon} />}
          </div>
          <Typography>{label}</Typography>
        </div>
      )),
    [items],
  );

  return <div className={styles.root}>{itemsJSX}</div>;
};

ActionPoints.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      completed: PropTypes.bool,
    }),
  ).isRequired,
};

export default memo(ActionPoints);
